var map = {
	"./Logo.syr-gos": [
		28256,
		[
			256
		]
	],
	"./Logo.syr-gos.tsx": [
		28256,
		[
			256
		]
	],
	"./Logo.ukraine": [
		32151,
		[
			151
		]
	],
	"./Logo.ukraine.tsx": [
		32151,
		[
			151
		]
	]
};
function webpackAsyncContext(req) {
	try {
		if(!__webpack_require__.o(map, req)) {
			return Promise.resolve().then(() => {
	var e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
});
		}
	} catch(err) {
		return Promise.reject(err);
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1][0]).then(() => (__webpack_require__(id)));
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 80798;
module.exports = webpackAsyncContext;